import {
  RBAC_V2_ACTION_LABELS,
  RBAC_V2_FEATURE_LABELS,
  RBAC_V2_MODULE_LABELS,
  RBAC_V2_SUBTAB_LABELS,
  type RbacV2Action,
  type RbacV2Resource,
  rbacV2Resources,
} from '@gozoki/api-types'
import type { PermissionTuple } from '~/utils/ability'

const v2ResourceSet = new Set<string>(rbacV2Resources)

export interface DescribedPermission {
  /** Clé stable pour le rendu (`action:resource`). */
  key: string
  /** Libellé de l'action (« Voir », « Modifier », action spéciale…). */
  actionLabel: string
  /** Chemin lisible de la ressource (module › sous-onglet › fonctionnalité). */
  segments: string[]
}

/**
 * Traduit un tuple de permission `[action, resource]` en libellés lisibles, par les maps
 * `RBAC_V2_*_LABELS` de `@gozoki/api-types` (module / sous-onglet / feature). Un couple hors
 * taxonomie (refus serveur inattendu) garde ses libellés bruts.
 */
export const describePermission = ([action, resource]: PermissionTuple): DescribedPermission => {
  const key = `${String(action)}:${resource}`

  if (v2ResourceSet.has(resource)) {
    const [moduleKey, subtabKey] = resource.split('.')
    const segments = [
      RBAC_V2_MODULE_LABELS[moduleKey],
      RBAC_V2_SUBTAB_LABELS[`${moduleKey}.${subtabKey}`],
      RBAC_V2_FEATURE_LABELS[resource as RbacV2Resource],
    ].filter((segment): segment is string => Boolean(segment))

    return {
      key,
      actionLabel: RBAC_V2_ACTION_LABELS[action as RbacV2Action] ?? String(action),
      segments,
    }
  }

  return { key, actionLabel: String(action), segments: [resource] }
}
